export default {
  data: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/certificates/state.js